import { render, staticRenderFns } from "./bottom2.vue?vue&type=template&id=4d682795&scoped=true"
import script from "./bottom2.vue?vue&type=script&lang=js"
export * from "./bottom2.vue?vue&type=script&lang=js"
import style0 from "./bottom2.vue?vue&type=style&index=0&id=4d682795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d682795",
  null
  
)

export default component.exports